module.exports = __webpack_public_path__ + "static/media/charles82.39b9862d.png";